import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, AuthService, GenesisUnitOfWork, SessionInformationService } from 'app/core/core.module';
import { Vendor } from 'app/core/model/vendor';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { confirm } from 'devextreme/ui/dialog';
import _ from 'lodash';

@Component({
    selector: 'app-vendor-search',
    templateUrl: './vendor-search.component.html',
    styleUrls: ['./vendor-search.component.scss'],
    standalone: false
})
export class VendorSearchComponent implements OnInit {
    vendors: any;
    filter: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private appInfo: AppInformationService,
        private sessionInfo: SessionInformationService
    ) {}

    async ngOnInit() {
        this.filter = this.sessionInfo.getItem('vendor-search-filter') ?? { showAll: false };
        await this.getData();
    }

    async getData() {
        this.vendors = await this.uow.getVendors(!this.filter.showAll);
        this.sessionInfo.setItem('vendor-search-filter', this.filter);
    }

    async delete(selection: any) {
        const result = await (confirm(`Are you sure you want to DELETE this vendor?`, `${this.appInfo.settings.company}`) as Promise<boolean>);
        if (!!result) {
            selection.forEach((row) => {
                row.deleted = new Date();
            });
            await this.uow.commit();
            await this.getData();
        }
    }

    selectionChange(e) {}

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async open(id: number) {
        this.router.navigate(['/vendors/overview/' + (!!id ? id : 'new')]);
    }

    async rowDoubleClick(e) {
        if (!e.data || !e.data.id) return;
        this.open(e.data.id);
    }

    async toggleShowAll() {
        this.dataGrid.instance.clearSelection();
        this.filter.showAll = !this.filter.showAll;
        await this.getData();
    }

    async toggleInactive(vendors: Vendor[]) {
        if (!vendors || vendors.length === 0) return;

        this.appInfo.pleaseWaitShow();

        const toggle = _.some(vendors, 'inactive');
        vendors.forEach((vendor) => {
            if (toggle) vendor.inactive = null;
            else vendor.inactive = new Date();
        });
        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
